/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { v4 as uuid } from "uuid";
let memoId = "";
export const getMemoId = () => memoId;
export const memo = (fn) => {
    const id = uuid();
    const handler = {
        apply: (target, thisArg, argumentsList) => {
            memoId = id;
            return target(...argumentsList);
        },
    };
    const proxy = new Proxy(fn, handler);
    return proxy;
};
//# sourceMappingURL=index.js.map